module.exports = __webpack_public_path__ + "static/img/bg_aboutUS.ce504fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/bg_aboutUS.jpg
// module id = hYI6
// module chunks = 7